export type BusinessCenterRuntimeMode = "development" | "demo" | "production";

function readRuntimeModeFromStorage() {
  try {
    return typeof window !== "undefined" ? window.localStorage.getItem("ktd_runtime_mode") : null;
  } catch {
    return null;
  }
}

export function getRuntimeMode(): BusinessCenterRuntimeMode {
  const explicitMode = import.meta.env.VITE_KTD_RUNTIME_MODE?.trim().toLowerCase();
  if (explicitMode === "development" || explicitMode === "demo" || explicitMode === "production") {
    return explicitMode;
  }

  if (import.meta.env.VITE_KTD_DEMO_MODE === "true") return "demo";

  if (import.meta.env.DEV) {
    const storedMode = readRuntimeModeFromStorage()?.trim().toLowerCase();
    if (storedMode === "development" || storedMode === "demo" || storedMode === "production") {
      return storedMode;
    }
    return "development";
  }

  return "production";
}

export function isDevelopmentMode() {
  return getRuntimeMode() === "development";
}

export function isDemoRuntimeMode() {
  return getRuntimeMode() === "demo";
}

export function isProductionRuntimeMode() {
  return getRuntimeMode() === "production";
}

export function getDemoAuthRole() {
  if (!isDemoRuntimeMode()) return null;
  try {
    return typeof window !== "undefined" ? window.localStorage.getItem("ktd_demo_auth") : null;
  } catch {
    return null;
  }
}

export function setDemoAuthRole(role: "admin" | "client") {
  if (!isDemoRuntimeMode()) return;
  try {
    if (typeof window !== "undefined") window.localStorage.setItem("ktd_demo_auth", role);
  } catch {
    // Ignore storage failures in hardened or private browsing contexts.
  }
}

export function clearDemoAuthRole() {
  try {
    if (typeof window !== "undefined") window.localStorage.removeItem("ktd_demo_auth");
  } catch {
    // Ignore storage failures in hardened or private browsing contexts.
  }
}

export function setDemoRuntimeMode(mode: BusinessCenterRuntimeMode) {
  try {
    if (typeof window !== "undefined") window.localStorage.setItem("ktd_runtime_mode", mode);
  } catch {
    // Ignore storage failures in hardened or private browsing contexts.
  }
}
